// extracted by mini-css-extract-plugin
module.exports = {"mb12":"index_mb12_3bnq3","title":"index_title_3edCF"};